var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h2>Premium services</h2>\n<pkp-admin-rest-api api-variant=\"'SSO'\"></pkp-admin-rest-api>\n<pkp-storage-admin-allocation-algorithm-activation></pkp-storage-admin-allocation-algorithm-activation>\n<pkp-storage-admin-fcfs-service-activation></pkp-storage-admin-fcfs-service-activation>\n<pkp-storage-admin-prisma-credit-limit-check></pkp-storage-admin-prisma-credit-limit-check>\n";
var id1="app/storage-admin/storage-admin-premium-services.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;